export const chartTypes = Object.freeze({
    TIMELINE: 'timeLine',
    LINEARBUBBLE: 'linearBubble',
    ORDINALLINE: 'ordinalLine',
    GROUPEDBAR: 'groupedBar',
    SWOT: 'swot'
});
